import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { I18nService } from '../../i18n/i18n.service';
import { Lang, LANGUAGES } from '../../i18n/language';

/**
 * Przełącznik języka w nagłówku. Wybór trafia do localStorage, więc trzyma się
 * między wizytami; przy pierwszej decyduje język przeglądarki.
 */
@Component({
    selector: 'app-language-switcher',
    templateUrl: './language-switcher.component.html',
    styleUrls: ['./language-switcher.component.css'],
    standalone: true,
    imports: [MatButtonModule, MatMenuModule, MatTooltipModule]
})
export class LanguageSwitcherComponent {

  readonly languages = LANGUAGES;

  constructor(public i18n: I18nService) { }

  get current() {
    return this.languages.find((entry) => entry.code === this.i18n.lang) ?? this.languages[0];
  }

  select(lang: Lang) {
    this.i18n.setLang(lang);
  }
}
